import message from 'antd/lib/message';
import Spin from 'antd/lib/spin';
import Tabs from 'antd/lib/tabs';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { fetchBids } from 'src/api/shipmentExecution';
import { RfqBidType } from '../../../SE.interfaces';
import SEBidReasonModal from '../../../SEActions/SETasks/addEdit/SEBidReasonModal';
import RfqBids from './RfqBids';

const TabPane = Tabs.TabPane;

interface RfqBidContainerTabs {

};

const RfqBidContainerTabs = (props) => {
  const { field } = props;
  const [isFetchingBids, setIsFetchingBids] = useState<boolean>(false);
  // const [bids, setBids] = useState<Record<string, RfqBidType[]>>();
  const [bids, setBids] = useState<any>({});
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [selectedFF, setSelectedFF] = useState<string | undefined>(undefined);
  const [selectedCarrier, setSelectedCarrier] = useState<string | undefined>(undefined);
  const [selectedBids, setSelectedBids] = useState<Record<string, RfqBidType[] | undefined> | undefined>(undefined); // Object with one bid(value) in each type(key)
  const [selectedBidId, setSelectedBidId] = useState<string | undefined>(undefined);
  const [bidSelectionReason, setBidSelectionReason] = useState<string | undefined>();
  const [isBidSelectionReasonModalVisible, setIsBidSelectionReasonModalVisible] = useState<boolean>(false);
  const [primaryContainerSizeType, setPrimaryContainerSizeType] = useState<string>("");
  const [isInitialAssignment, setIsInitialAssignment] = useState<boolean>(true);
  const { shipmentExecutionId } = props.field?.extraData || {};

  // fetching bid list ///////////////////
  const setData = async () => {
    if (!shipmentExecutionId) return;
    setIsFetchingBids(true);

    const response = await fetchBids({ id: shipmentExecutionId });
    if (response.isSuccess) {
      if (!response.data) {
        message.error("Unable to fetch data.");
        return;
      }

      setPrimaryContainerSizeType(response.data?.primaryContainerSizeType);

      setBids({
        ...response?.data?.bids,
      });
      
      setErrorMessage('');
    } else {
      setErrorMessage(response.errorMessage);
    }
    setIsFetchingBids(false);
  };

  useEffect(() => {
    if (field?.disabled) {
      return;
    }
    setData();
  }, [props.field?.extraData?.shipmentExecutionId]);

  useEffect(() => {
    if (field?.disabled) {
      setPrimaryContainerSizeType(field.value.primaryContainerSizeType);
      setBids(field.value.bids);
    }
    if (field?.value.bids && isInitialAssignment) {
      setSelectedBids(field.value.bids);
      setBidSelectionReason(field.value.bidSelectionReason);
      setIsInitialAssignment(false);
    }
  }, [field?.value]);

  // ff from any of the selected bid //////////////////////////////////
  const setFiltersByAnySelectedBid = (selectedBids: Record<string, RfqBidType[] | undefined> | undefined) => {
    if (!selectedBids) return;

    const anySelectedBidKey = Object.keys(selectedBids)
      .filter((category) => tabTitles?.includes(category))?.find(category => {
        const selectedBidOfCategory = selectedBids[category]?.[0];
        return selectedBidOfCategory;
    });
    
    if (anySelectedBidKey) {
      setSelectedCarrier(selectedBids[anySelectedBidKey]?.[0]?.carrierId);
      setSelectedFF(selectedBids[anySelectedBidKey]?.[0]?.ffId);
      return;
    }
    setSelectedFF(undefined);  
    setSelectedCarrier(undefined);
  }

  useEffect(() => {
    setFiltersByAnySelectedBid(selectedBids);
    if (field) {
      field.setValue({ bids: selectedBids, primaryContainerSizeType, bidSelectionReason });
      setIsInitialAssignment(false);
    }

    if (!selectedBids || !primaryContainerSizeType) {
      return;
    }

  }, [selectedBids, primaryContainerSizeType]);

  useEffect(() => {
    if (field) {
      field.setValue({ bids: selectedBids, primaryContainerSizeType, bidSelectionReason })
    }
  }, [bidSelectionReason]);

  const onBidSelection = (bid: RfqBidType, category: string) => {
    if (category === primaryContainerSizeType) {
      if (bid && bid.rank !== 1) {
        setIsBidSelectionReasonModalVisible(true);
      } else if (!bid) {
        setBidSelectionReason(undefined);
      }
    }

    setSelectedBids({
      ...selectedBids,
      [category]: [bid],
    });
  }

  const renderSelectionReason = () => {
    return bidSelectionReason && (
      <div style={{ paddingBottom: 28, paddingTop: 10 }}>
        <div>Reason for L1 deviation</div>
        <div
          style={{
            fontWeight: 600,
            marginTop: 5,
            lineHeight: 1.8,
            color: '#111111',
          }}
        >
          {bidSelectionReason}
        </div>
      </div>
    );
  };

  const changeBidSelectionReason = async (reason: string) => {
    setIsBidSelectionReasonModalVisible(false);
    setBidSelectionReason(reason);
  };

  const renderBidReasonModal = () => {
    return (
      <SEBidReasonModal
        visible={isBidSelectionReasonModalVisible}
        handleSubmit={changeBidSelectionReason}
        handleClose={() => {
          setSelectedBids({
            ...selectedBids,
            [primaryContainerSizeType]: undefined,
          });
          setIsBidSelectionReasonModalVisible(false);
        }}
      />
    );
  };

  if (isFetchingBids) {
    return <div style={{ width: '120%', textAlign: 'center' }}>
      <Spin />
    </div>;
  }

  const tabTitles = Object.keys(bids || {});

  const index = tabTitles.indexOf(primaryContainerSizeType);

  if (index > -1) {
    tabTitles.splice(index, 1);
    tabTitles.unshift(primaryContainerSizeType);
  }

  const resetBids = () => {
    const emptySelectedBids = {};
    tabTitles.forEach(category => {
      emptySelectedBids[category] = [];
    });

    setSelectedBids(emptySelectedBids);
    setBidSelectionReason(undefined);
  }

  const renderNoBidAvailable = () => {
    return (
      <div style={{ color: '#DF1D1D', fontSize: 12 }}>
        There is no bid available.
      </div>
    )
  }
  return <div style={{ width: '122%' }}>
    {renderSelectionReason()}
    {!tabTitles.length ? renderNoBidAvailable() :
      (<Tabs type="card" style={{ width: 'fit-content' }}>
        {tabTitles.map(category => {
          const filteredBidList = bids?.[category] ?
            bids?.[category].filter(bid => {
              // filtering if selectedFF or selectedCarrier is present 
              let isValid = true;
              if (selectedFF) {
                isValid = isValid && selectedFF === bid.ffId;
              }

              if (selectedCarrier && isValid) {
                isValid = isValid && selectedCarrier === bid.carrierId;
              }

              return isValid;
            }) :
            bids?.[category];
          const selectedBid = selectedBids?.[category]?.[0];  // assuming value to be an array with one element
          return (<TabPane key={category} tab={category || 'Bids'}>
            <RfqBids
              selectedBid={selectedBid}
              onBidSelection={(bid) => onBidSelection(bid, category)}
              bidList={filteredBidList}
              category={category}
              resetBids={resetBids}
              {...props}
            />
          </TabPane>);
        })}
      </Tabs>)}
    {isBidSelectionReasonModalVisible && renderBidReasonModal()}
  </div>;
}

export default RfqBidContainerTabs;